import { render, staticRenderFns } from "./DetailsCollapse.vue?vue&type=template&id=fab76e82&scoped=true"
import script from "./DetailsCollapse.vue?vue&type=script&lang=js"
export * from "./DetailsCollapse.vue?vue&type=script&lang=js"
import style0 from "./DetailsCollapse.vue?vue&type=style&index=0&id=fab76e82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab76e82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fab76e82')) {
      api.createRecord('fab76e82', component.options)
    } else {
      api.reload('fab76e82', component.options)
    }
    module.hot.accept("./DetailsCollapse.vue?vue&type=template&id=fab76e82&scoped=true", function () {
      api.rerender('fab76e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/services/components/DetailsCollapse.vue"
export default component.exports